import { useState, useEffect, useLayoutEffect } from "react";
import useFetch from "../../../utils/useFetch";
import TickRoundIcon from "../../../icons/TickRoundIcon";
import HourglassIcon from "../../../icons/HourglassIcon";
import TriangleExclamationIcon from "../../../icons/TriangleExclamationIcon";
import CollectionsTemplate from "../../../components/CollectionsTemplate/index";
import EmptyComponent from "../../../utils/EmptyComponent";
import apiinfo from "../../../utils/base-uri.json";
import axios from "../../../utils/fvAxios";
import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";
import NotificationCollectionControl from "./NotificationCollectionControl";
import NotificationaGriditem from "./NotificationaGriditem";
import NotificationListitem from "./NotificationListitem";



const pageSize = 12;
const queryUrl = "AdminVendors/GetOrgNotifications";

function vendorDataAdaptor(data, t) {
  return {
    headers: [
      { id: "vendorName", text: t("Dashboard.vendorName"), width: "25%" },
      {
        id: "Purpose",
        text: "Purpose",
        width: "30%",
      },
      {
        id: "Email Sent Date",
        text: "Email Sent Date",
        width: "30%",
      },
      { id: "clientName", text: t("Dashboard.client"), width: "20%" },

    ],
    isEditable: {
      callback: (item) => {
        console.log(item);
      },
      isVisible: true,
    },
    isDeletable: {
      callback: (item) => {
        console.log(item);
      },
      isVisible: true,
    },
    rows: data?.data?.map((d) =>
      Object.assign({}, d, {
        key: d.prequalificationId,
      })
    ),
    statusRoleMap: {
      prequalified: {
        text: "Prequalified",
        role: "success",
        icon: TickRoundIcon,
      },
      pending: { text: "Pending", role: "warning", icon: HourglassIcon },
      clientReview: {
        text: "Client Review",
        role: "warningLight",
        icon: HourglassIcon,
      },
      Expired: {
        text: "Expired",
        role: "warningLight",
        icon: TriangleExclamationIcon,
      },
      Probation: {
        text: "Probation",
        role: "error",
        icon: TriangleExclamationIcon,
      },
    },
  };
}

export default function () {
  function toQueryString(obj) {
    return "?".concat(
      Object.keys(obj)
        .map((e) =>
          obj[e] ? `${encodeURIComponent(e)}=${encodeURIComponent(obj[e])}` : null
        )
        .filter((e) => !!e)
        .join("&")
    );
  }

  function getUrl(url, data) {
    return `${url}${toQueryString(data)}`;
  }

  const [viewType, setViewType] = useState("grid");
  const [pageCount, setPageCount] = useState(1);
  const [countInfo, setCountInfo] = useState();
  const [collection, setCollection] = useState({});
  const [paramsState, setParamsState] = useState({
    pageNumber: 1,
    pageSize: 12,
    freeText: ""
  });
  const [url, setUrl] = useState(
    getUrl(queryUrl, { ...paramsState, pageSize })
  );
  const { data: collectionData, loading, error } = useFetch(url);

  useLayoutEffect(() => {
    setUrl(getUrl(queryUrl, { ...paramsState, pageSize }));
  }, [paramsState]);

  // useLayoutEffect(() => {
  //   componentDidMount();
  // }, [paramsState.freeText]);


  const { t } = useTranslation();
  useLayoutEffect(() => {
    if (collectionData) {
      //setPageCount(Math.ceil((collectionData.count || pageSize) / pageSize));
      setPageCount(Math.ceil(collectionData.count / pageSize));
      setCollection(
        vendorDataAdaptor ? vendorDataAdaptor(collectionData, t) : collectionData
      );
    }
  }, [collectionData]);

  function toggleViewType() {
    setViewType(viewType === "list" ? "grid" : "list");
  }

  function setSearchStr(str) {
    setParamsState({ ...paramsState, freeText: str, pageNumber: 1 });
  }

  function setPage(pageNumber) {
    setParamsState((prev) => ({ ...prev, pageNumber }));
  }

  return (
    <CollectionsTemplate
      TitlebarChildren={EmptyComponent}
      page={paramsState.pageNumber}
      setPage={setPage}
      pageCount={pageCount}
      fetchState={{ loading, error }}
      collection={collection}
      viewType={viewType}
      responseDataAdaptor={vendorDataAdaptor}
      ListItemComponent={NotificationListitem}
      GridItemComponent={NotificationaGriditem}
      CollectionControls={(props) => (
        <NotificationCollectionControl
          setSearchStr={setSearchStr}
          searchStr={paramsState.freeText}
          toggleViewType={toggleViewType}
          viewType={viewType}
          IsDownload={url}
          searchPlaceholder="Search vendors"
          countInfo={countInfo}
          {...props}
        />
      )}
    />
  );
}

